import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TuiInputPin } from '@taiga-ui/kit';
import { TuiTextfield } from '@taiga-ui/core';

import { InputCodeComponent } from './input-code.component';

@NgModule({
  declarations: [InputCodeComponent],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, ...TuiTextfield, TuiInputPin],
  exports: [InputCodeComponent],
})
export class InputCodeModule {}
